var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _circle, _circle2, _path3, _circle3, _circle4, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 110,
    viewBox: "0 0 224 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 72,
    width: 167,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 21.5,
    width: 59,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 48.5,
    width: 149,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 1.5,
    width: 45,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 5.5,
    width: 17,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 206.5,
    y: 54.5,
    width: 17,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 60.5H153.5C146.861 61.7449 146.861 71.2551 153.5 72.5H65.5C71.9611 71.3462 72.2736 62.1934 65.9063 60.6016L65.5 60.5Z",
    fill: "#E2F7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 13.5H178.5C175.425 15.2802 175.425 19.7198 178.5 21.5H159.5C162.355 19.9256 162.662 15.9407 160.081 13.9483L159.5 13.5Z",
    fill: "#E2F7E7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 7.5,
    r: 6.5,
    stroke: "#54CB69"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 153.5,
    cy: 103.5,
    r: 5.5,
    stroke: "#54CB69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.85 43.15V46.5H206.65V43.15H210V41.35H206.65V38H204.85V41.35H201.5V43.15H204.85Z",
    fill: "#54CB69"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 56,
    r: 44,
    fill: "#E2F7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 56,
    r: 34,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143 52.7114V55.5174C142.996 62.0945 140.867 68.4942 136.928 73.762C132.99 79.0298 127.455 82.8835 121.148 84.7483C114.841 86.6132 108.1 86.3892 101.93 84.1099C95.7606 81.8306 90.4932 77.618 86.9134 72.1005C83.3337 66.5829 81.6334 60.056 82.0661 53.4932C82.4989 46.9304 85.0415 40.6832 89.3148 35.6835C93.588 30.6838 99.363 27.1994 105.778 25.7499C112.194 24.3004 118.906 24.9636 124.914 27.6405",
    stroke: "#54CB69",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 43.5V60L123 65.5",
    stroke: "#54CB69",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionInProgress);
export default __webpack_public_path__ + "static/media/transactionInProgress.b2975d7097015955f304c36197ffd738.svg";
export { ForwardRef as ReactComponent };